/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Prefecture } from './Prefecture';
import {
    PrefectureFromJSON,
    PrefectureFromJSONTyped,
    PrefectureToJSON,
} from './Prefecture';

/**
 * 
 * @export
 * @interface DeliverableAddress
 */
export interface DeliverableAddress {
    /**
     * 
     * @type {string}
     * @memberof DeliverableAddress
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverableAddress
     */
    zipCode: string;
    /**
     * 
     * @type {Prefecture}
     * @memberof DeliverableAddress
     */
    prefecture: Prefecture;
    /**
     * 
     * @type {string}
     * @memberof DeliverableAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof DeliverableAddress
     */
    town: string;
}

/**
 * Check if a given object implements the DeliverableAddress interface.
 */
export function instanceOfDeliverableAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "zipCode" in value;
    isInstance = isInstance && "prefecture" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "town" in value;

    return isInstance;
}

export function DeliverableAddressFromJSON(json: any): DeliverableAddress {
    return DeliverableAddressFromJSONTyped(json, false);
}

export function DeliverableAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverableAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'zipCode': json['zip_code'],
        'prefecture': PrefectureFromJSON(json['prefecture']),
        'city': json['city'],
        'town': json['town'],
    };
}

export function DeliverableAddressToJSON(value?: DeliverableAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'zip_code': value.zipCode,
        'prefecture': PrefectureToJSON(value.prefecture),
        'city': value.city,
        'town': value.town,
    };
}

